/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DownSavingCancelRequest } from '../models/DownSavingCancelRequest';
import type { DownSavingCreateRequest } from '../models/DownSavingCreateRequest';
import type { DownSavingPaymentDetailResponse } from '../models/DownSavingPaymentDetailResponse';
import type { DownSavingReportCsvRequest } from '../models/DownSavingReportCsvRequest';
import type { DownSavingReportCsvResponse } from '../models/DownSavingReportCsvResponse';
import type { DownSavingResponse } from '../models/DownSavingResponse';
import type { DownSavingStatementPaymentDetailRequest } from '../models/DownSavingStatementPaymentDetailRequest';
import type { DownSavingStatusUpdateRequest } from '../models/DownSavingStatusUpdateRequest';
import type { DownSavingTransactionCreateRequest } from '../models/DownSavingTransactionCreateRequest';
import type { DownSavingTransactionResponse } from '../models/DownSavingTransactionResponse';
import type { DownSavingTransactionSumResponse } from '../models/DownSavingTransactionSumResponse';
import type { DownSavingUpdateRequest } from '../models/DownSavingUpdateRequest';
import type { PageDownSavingAuditDto } from '../models/PageDownSavingAuditDto';
import type { PaginatedDownSavingResponse } from '../models/PaginatedDownSavingResponse';
import type { PaginatedDownSavingStatementResponse } from '../models/PaginatedDownSavingStatementResponse';
import type { SearchDownSavingSummaryResponse } from '../models/SearchDownSavingSummaryResponse';
import type { Unit } from '../models/Unit';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DownSavingService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns PaginatedDownSavingResponse OK
     * @throws ApiError
     */
    public searchDownSavings({
        shopId,
        searchText,
        startDateFrom,
        startDateTo,
        scheduledDateFrom,
        scheduledDateTo,
        status,
        startDownTarget,
        endDownTarget,
        startProductPrice,
        endProductPrice,
        page,
        limit,
    }: {
        shopId?: string,
        searchText?: string,
        startDateFrom?: string,
        startDateTo?: string,
        scheduledDateFrom?: string,
        scheduledDateTo?: string,
        status?: Array<'ACTIVE' | 'CLOSED' | 'DATA_LOSS' | 'LINE_BLOCKED_DEVICE_RECEIVE' | 'LINE_BLOCKED_DEVICE_NOT_RECEIVE' | 'CANCELLED' | 'WITHDRAWN'>,
        startDownTarget?: string,
        endDownTarget?: string,
        startProductPrice?: string,
        endProductPrice?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<PaginatedDownSavingResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/down-savings',
            query: {
                'shopId': shopId,
                'searchText': searchText,
                'startDateFrom': startDateFrom,
                'startDateTo': startDateTo,
                'scheduledDateFrom': scheduledDateFrom,
                'scheduledDateTo': scheduledDateTo,
                'status': status,
                'startDownTarget': startDownTarget,
                'endDownTarget': endDownTarget,
                'startProductPrice': startProductPrice,
                'endProductPrice': endProductPrice,
                'page': page,
                'limit': limit,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns DownSavingResponse OK
     * @throws ApiError
     */
    public createDownSaving({
        requestBody,
    }: {
        requestBody: DownSavingCreateRequest,
    }): CancelablePromise<DownSavingResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/down-savings',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns DownSavingResponse OK
     * @throws ApiError
     */
    public updateDownSaving({
        requestBody,
    }: {
        requestBody: DownSavingUpdateRequest,
    }): CancelablePromise<DownSavingResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/down-savings',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns DownSavingResponse OK
     * @throws ApiError
     */
    public cancelDownSaving({
        requestBody,
    }: {
        requestBody: DownSavingCancelRequest,
    }): CancelablePromise<DownSavingResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/down-savings/{downSavingId}/cancel',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns DownSavingTransactionResponse OK
     * @throws ApiError
     */
    public getTransactions({
        downSavingId,
    }: {
        downSavingId: string,
    }): CancelablePromise<Array<DownSavingTransactionResponse>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/down-savings/transactions',
            query: {
                'downSavingId': downSavingId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns DownSavingTransactionResponse OK
     * @throws ApiError
     */
    public createDownSavingTransaction({
        requestBody,
    }: {
        requestBody: DownSavingTransactionCreateRequest,
    }): CancelablePromise<DownSavingTransactionResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/down-savings/transactions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns DownSavingPaymentDetailResponse OK
     * @throws ApiError
     */
    public getDownSavingStatementPaymentDetail({
        requestBody,
    }: {
        requestBody: DownSavingStatementPaymentDetailRequest,
    }): CancelablePromise<DownSavingPaymentDetailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/down-savings/statement/payment-detail',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns DownSavingReportCsvResponse OK
     * @throws ApiError
     */
    public generateCsvReportDownSaving({
        requestBody,
    }: {
        requestBody: DownSavingReportCsvRequest,
    }): CancelablePromise<DownSavingReportCsvResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/down-savings/report/csv',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns Unit OK
     * @throws ApiError
     */
    public updateDownSavingStatus({
        downSavingId,
        requestBody,
    }: {
        downSavingId: string,
        requestBody: DownSavingStatusUpdateRequest,
    }): CancelablePromise<Unit> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/down-savings/{downSavingId}/status',
            path: {
                'downSavingId': downSavingId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns DownSavingResponse OK
     * @throws ApiError
     */
    public getDownSaving({
        downSavingId,
    }: {
        downSavingId: string,
    }): CancelablePromise<DownSavingResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/down-savings/{downSavingId}',
            path: {
                'downSavingId': downSavingId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns PageDownSavingAuditDto OK
     * @throws ApiError
     */
    public getDownSavingAuditByDownSavingId({
        downSavingId,
        page,
        limit = 10,
    }: {
        downSavingId: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<PageDownSavingAuditDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/down-savings/{downSavingId}/audits',
            path: {
                'downSavingId': downSavingId,
            },
            query: {
                'page': page,
                'limit': limit,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns SearchDownSavingSummaryResponse OK
     * @throws ApiError
     */
    public searchDownSavingSummary({
        shopId,
        searchText,
        startDateFrom,
        startDateTo,
        scheduledDateFrom,
        scheduledDateTo,
        status,
        startDownTarget,
        endDownTarget,
        startProductPrice,
        endProductPrice,
        page,
        limit,
    }: {
        shopId?: string,
        searchText?: string,
        startDateFrom?: string,
        startDateTo?: string,
        scheduledDateFrom?: string,
        scheduledDateTo?: string,
        status?: Array<'ACTIVE' | 'CLOSED' | 'DATA_LOSS' | 'LINE_BLOCKED_DEVICE_RECEIVE' | 'LINE_BLOCKED_DEVICE_NOT_RECEIVE' | 'CANCELLED' | 'WITHDRAWN'>,
        startDownTarget?: string,
        endDownTarget?: string,
        startProductPrice?: string,
        endProductPrice?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<SearchDownSavingSummaryResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/down-savings/summary',
            query: {
                'shopId': shopId,
                'searchText': searchText,
                'startDateFrom': startDateFrom,
                'startDateTo': startDateTo,
                'scheduledDateFrom': scheduledDateFrom,
                'scheduledDateTo': scheduledDateTo,
                'status': status,
                'startDownTarget': startDownTarget,
                'endDownTarget': endDownTarget,
                'startProductPrice': startProductPrice,
                'endProductPrice': endProductPrice,
                'page': page,
                'limit': limit,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns PaginatedDownSavingStatementResponse OK
     * @throws ApiError
     */
    public getDownSavingStatement({
        shopId,
        searchText,
        startDateFrom,
        startDateTo,
        status,
        savingDirection,
        page,
        limit,
    }: {
        shopId: string,
        searchText?: string,
        startDateFrom?: string,
        startDateTo?: string,
        status?: Array<'ACTIVE' | 'CLOSED' | 'DATA_LOSS' | 'LINE_BLOCKED_DEVICE_RECEIVE' | 'LINE_BLOCKED_DEVICE_NOT_RECEIVE' | 'CANCELLED' | 'WITHDRAWN'>,
        savingDirection?: Array<'DEPOSIT' | 'WITHDRAW'>,
        page?: number,
        limit?: number,
    }): CancelablePromise<PaginatedDownSavingStatementResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/down-savings/statements',
            query: {
                'shopId': shopId,
                'searchText': searchText,
                'startDateFrom': startDateFrom,
                'startDateTo': startDateTo,
                'status': status,
                'savingDirection': savingDirection,
                'page': page,
                'limit': limit,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns DownSavingTransactionSumResponse OK
     * @throws ApiError
     */
    public getDownSavingSummaryStatement({
        shopId,
        searchText,
        startDateFrom,
        startDateTo,
        status,
        savingDirection,
        page,
        limit,
    }: {
        shopId: string,
        searchText?: string,
        startDateFrom?: string,
        startDateTo?: string,
        status?: Array<'ACTIVE' | 'CLOSED' | 'DATA_LOSS' | 'LINE_BLOCKED_DEVICE_RECEIVE' | 'LINE_BLOCKED_DEVICE_NOT_RECEIVE' | 'CANCELLED' | 'WITHDRAWN'>,
        savingDirection?: Array<'DEPOSIT' | 'WITHDRAW'>,
        page?: number,
        limit?: number,
    }): CancelablePromise<DownSavingTransactionSumResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/down-savings/statements/summary',
            query: {
                'shopId': shopId,
                'searchText': searchText,
                'startDateFrom': startDateFrom,
                'startDateTo': startDateTo,
                'status': status,
                'savingDirection': savingDirection,
                'page': page,
                'limit': limit,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns boolean OK
     * @throws ApiError
     */
    public softDeleteTransaction({
        transactionId,
        shopId,
    }: {
        transactionId: string,
        shopId: string,
    }): CancelablePromise<boolean> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v1/down-savings/transaction/{transactionId}',
            path: {
                'transactionId': transactionId,
            },
            query: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
